// extracted by mini-css-extract-plugin
module.exports = {"FilterPillsContainer":"pills_FilterPillsContainer__r8Lkm","hide":"pills_hide__b48vB","scroll":"pills_scroll__Z1oUn","padding":"pills_padding__8oKMp"};